/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
};

export type CalendarWidgetInfo = {
  __typename?: 'CalendarWidgetInfo';
  endDate?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
  tournamentName?: Maybe<Scalars['String']['output']>;
  tournamentPlace?: Maybe<Scalars['String']['output']>;
  tournamentType?: Maybe<Scalars['String']['output']>;
};

export type CalendarWidgetInfoInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  tournamentPlace?: InputMaybe<Scalars['String']['input']>;
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson: Scalars['AWSJSON']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateSdapiCalendarWidgetInput = {
  circuitCalendarLink?: InputMaybe<Scalars['String']['input']>;
  circuitType: Scalars['String']['input'];
  filterList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentFilter: Scalars['String']['input'];
  tournaments?: InputMaybe<Array<InputMaybe<CalendarWidgetInfoInput>>>;
};

export type CreateSdapiCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  competitionJson: Scalars['AWSJSON']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  sex?: InputMaybe<Scalars['String']['input']>;
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSdapiLiveScoreWidgetInput = {
  ctaUrls?: InputMaybe<LiveScoreWidgetCtaUrlInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  liveTournaments?: InputMaybe<Array<InputMaybe<LiveScoreWidgetTournamentInput>>>;
};

export type CreateSdapiMatchInput = {
  competitionId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['ID']['input'];
  matchLiveJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchScheduleJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerA1Id?: InputMaybe<Scalars['ID']['input']>;
  playerA2Id?: InputMaybe<Scalars['ID']['input']>;
  playerB1Id?: InputMaybe<Scalars['ID']['input']>;
  playerB2Id?: InputMaybe<Scalars['ID']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSdapiPlayerInput = {
  playerId: Scalars['ID']['input'];
  playerJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerStatsJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type CreateSdapiRankingInput = {
  circuitType: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
  rankingJson: Scalars['AWSJSON']['input'];
};

export type CreateSdapiRankingWidgetInput = {
  circuitType: Scalars['ID']['input'];
  rankings?: InputMaybe<Array<InputMaybe<RankingWidgetInfoInput>>>;
};

export type CreateSdapiResultsCategoriesWidgetInput = {
  adv?: InputMaybe<ResultsCategoriesWidgetAdvInput>;
  categories?: InputMaybe<Array<InputMaybe<ResultsCategoriesWidgetInfoInput>>>;
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type CreateSdapiResultsContainerWidgetInput = {
  seasonId: Scalars['ID']['input'];
  ssi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type CreateSdapiResultsWidgetInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['ID']['input'];
  matches?: InputMaybe<Array<InputMaybe<ResultsWidgetMatchInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CreateSdapiSeasonInput = {
  editorialData?: InputMaybe<Scalars['AWSJSON']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type CreateSdapiTournamentDataWidgetInput = {
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  messageType: Scalars['String']['input'];
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSdapiTournamentInput = {
  circuitType: Scalars['String']['input'];
  editorialDataId: Scalars['ID']['input'];
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentJson: Scalars['AWSJSON']['input'];
  type: Scalars['ID']['input'];
};

export type DeleteEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteSdapiCalendarWidgetInput = {
  circuitType: Scalars['String']['input'];
  tournamentFilter: Scalars['String']['input'];
};

export type DeleteSdapiCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteSdapiLiveScoreWidgetInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSdapiMatchInput = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteSdapiPlayerInput = {
  playerId: Scalars['ID']['input'];
};

export type DeleteSdapiRankingInput = {
  circuitType: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};

export type DeleteSdapiRankingWidgetInput = {
  circuitType: Scalars['ID']['input'];
};

export type DeleteSdapiResultsCategoriesWidgetInput = {
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type DeleteSdapiResultsContainerWidgetInput = {
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type DeleteSdapiResultsWidgetInput = {
  competitionId: Scalars['ID']['input'];
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteSdapiSeasonInput = {
  seasonId: Scalars['ID']['input'];
};

export type DeleteSdapiTournamentDataWidgetInput = {
  seasonAndTournamentType: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type DeleteSdapiTournamentInput = {
  seasonAndTournamentType: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type EditorialData = {
  __typename?: 'EditorialData';
  createdAt: Scalars['AWSDateTime']['output'];
  editorialDataId: Scalars['ID']['output'];
  editorialJson: Scalars['AWSJSON']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LiveScoreWidgetCtaUrl = {
  __typename?: 'LiveScoreWidgetCtaUrl';
  atpCalendarUrl?: Maybe<Scalars['String']['output']>;
  atpRankingUrl?: Maybe<Scalars['String']['output']>;
  wtaCalendarUrl?: Maybe<Scalars['String']['output']>;
  wtaRankingUrl?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetCtaUrlInput = {
  atpCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  atpRankingUrl?: InputMaybe<Scalars['String']['input']>;
  wtaCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  wtaRankingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetMatch = {
  __typename?: 'LiveScoreWidgetMatch';
  firstPosition?: Maybe<LiveScoreWidgetPosition>;
  resultType?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  secondPosition?: Maybe<LiveScoreWidgetPosition>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetMatchInput = {
  firstPosition?: InputMaybe<LiveScoreWidgetPositionInput>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  secondPosition?: InputMaybe<LiveScoreWidgetPositionInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetPlayer = {
  __typename?: 'LiveScoreWidgetPlayer';
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetPlayerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetPosition = {
  __typename?: 'LiveScoreWidgetPosition';
  isServing?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<Array<Maybe<LiveScoreWidgetPlayer>>>;
  score?: Maybe<Array<Maybe<LiveScoreWidgetScore>>>;
};

export type LiveScoreWidgetPositionInput = {
  isServing?: InputMaybe<Scalars['Boolean']['input']>;
  players?: InputMaybe<Array<InputMaybe<LiveScoreWidgetPlayerInput>>>;
  score?: InputMaybe<Array<InputMaybe<LiveScoreWidgetScoreInput>>>;
};

export type LiveScoreWidgetScore = {
  __typename?: 'LiveScoreWidgetScore';
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  set?: Maybe<Scalars['String']['output']>;
  tie?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetScoreInput = {
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  tie?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetTournament = {
  __typename?: 'LiveScoreWidgetTournament';
  categoryName?: Maybe<Scalars['String']['output']>;
  circuitType?: Maybe<Scalars['String']['output']>;
  competitionId?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Array<Maybe<LiveScoreWidgetMatch>>>;
  resultsUrl?: Maybe<Scalars['String']['output']>;
  seasonId?: Maybe<Scalars['String']['output']>;
  tournamentId?: Maybe<Scalars['String']['output']>;
  tournamentName?: Maybe<Scalars['String']['output']>;
  tournamentType?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetTournamentInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  circuitType?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['String']['input']>;
  matches?: InputMaybe<Array<InputMaybe<LiveScoreWidgetMatchInput>>>;
  resultsUrl?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['String']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type ModelBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelEditorialDataConnection = {
  __typename?: 'ModelEditorialDataConnection';
  items: Array<Maybe<EditorialData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelEditorialDataFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  editorialJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelEditorialDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelFloatFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelIDFilterInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIDKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIntFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelIntKeyConditionInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelSdapiCalendarWidgetConnection = {
  __typename?: 'ModelSdapiCalendarWidgetConnection';
  items: Array<Maybe<SdapiCalendarWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiCalendarWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiCalendarWidgetFilterInput>>>;
  circuitCalendarLink?: InputMaybe<ModelStringFilterInput>;
  circuitType?: InputMaybe<ModelStringFilterInput>;
  filterList?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelSdapiCalendarWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiCalendarWidgetFilterInput>>>;
  tournamentFilter?: InputMaybe<ModelStringFilterInput>;
};

export type ModelSdapiCompetitionConnection = {
  __typename?: 'ModelSdapiCompetitionConnection';
  items: Array<Maybe<SdapiCompetition>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiCompetitionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiCompetitionFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelSdapiCompetitionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiCompetitionFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonAndTournamentType?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  sex?: InputMaybe<ModelStringFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentType?: InputMaybe<ModelStringFilterInput>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelSdapiLiveScoreWidgetConnection = {
  __typename?: 'ModelSdapiLiveScoreWidgetConnection';
  items: Array<Maybe<SdapiLiveScoreWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiLiveScoreWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiLiveScoreWidgetFilterInput>>>;
  id?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelSdapiLiveScoreWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiLiveScoreWidgetFilterInput>>>;
};

export type ModelSdapiMatchConnection = {
  __typename?: 'ModelSdapiMatchConnection';
  items: Array<Maybe<SdapiMatch>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiMatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiMatchFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  date?: InputMaybe<ModelIntFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  matchLiveJson?: InputMaybe<ModelStringFilterInput>;
  matchScheduleJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelSdapiMatchFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiMatchFilterInput>>>;
  playerA1Id?: InputMaybe<ModelIDFilterInput>;
  playerA2Id?: InputMaybe<ModelIDFilterInput>;
  playerB1Id?: InputMaybe<ModelIDFilterInput>;
  playerB2Id?: InputMaybe<ModelIDFilterInput>;
  round?: InputMaybe<ModelStringFilterInput>;
  roundName?: InputMaybe<ModelStringFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelSdapiPlayerConnection = {
  __typename?: 'ModelSdapiPlayerConnection';
  items: Array<Maybe<SdapiPlayer>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiPlayerFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiPlayerFilterInput>>>;
  not?: InputMaybe<ModelSdapiPlayerFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiPlayerFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  playerJson?: InputMaybe<ModelStringFilterInput>;
  playerStatsJson?: InputMaybe<ModelStringFilterInput>;
};

export type ModelSdapiRankingConnection = {
  __typename?: 'ModelSdapiRankingConnection';
  items: Array<Maybe<SdapiRanking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiRankingFilterInput>>>;
  circuitType?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelSdapiRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiRankingFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  rank?: InputMaybe<ModelIntFilterInput>;
  rankingJson?: InputMaybe<ModelStringFilterInput>;
};

export type ModelSdapiRankingWidgetConnection = {
  __typename?: 'ModelSdapiRankingWidgetConnection';
  items: Array<Maybe<SdapiRankingWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiRankingWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiRankingWidgetFilterInput>>>;
  circuitType?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelSdapiRankingWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiRankingWidgetFilterInput>>>;
};

export type ModelSdapiResultsCategoriesWidgetConnection = {
  __typename?: 'ModelSdapiResultsCategoriesWidgetConnection';
  items: Array<Maybe<SdapiResultsCategoriesWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiResultsCategoriesWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiResultsCategoriesWidgetFilterInput>>>;
  not?: InputMaybe<ModelSdapiResultsCategoriesWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiResultsCategoriesWidgetFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentType?: InputMaybe<ModelIDFilterInput>;
};

export type ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyInput>;
};

export type ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyInput = {
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  tournamentType?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelSdapiResultsContainerWidgetConnection = {
  __typename?: 'ModelSdapiResultsContainerWidgetConnection';
  items: Array<Maybe<SdapiResultsContainerWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiResultsContainerWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiResultsContainerWidgetFilterInput>>>;
  not?: InputMaybe<ModelSdapiResultsContainerWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiResultsContainerWidgetFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  ssi?: InputMaybe<ModelStringFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentType?: InputMaybe<ModelIDFilterInput>;
};

export type ModelSdapiResultsContainerWidgetPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelSdapiResultsContainerWidgetPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelSdapiResultsContainerWidgetPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelSdapiResultsContainerWidgetPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelSdapiResultsContainerWidgetPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelSdapiResultsContainerWidgetPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelSdapiResultsContainerWidgetPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelSdapiResultsContainerWidgetPrimaryCompositeKeyInput>;
};

export type ModelSdapiResultsContainerWidgetPrimaryCompositeKeyInput = {
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  tournamentType?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelSdapiResultsWidgetConnection = {
  __typename?: 'ModelSdapiResultsWidgetConnection';
  items: Array<Maybe<SdapiResultsWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiResultsWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiResultsWidgetFilterInput>>>;
  categoryName?: InputMaybe<ModelStringFilterInput>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  date?: InputMaybe<ModelStringFilterInput>;
  day?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelSdapiResultsWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiResultsWidgetFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelSdapiResultsWidgetPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelSdapiResultsWidgetPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelSdapiResultsWidgetPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelSdapiResultsWidgetPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelSdapiResultsWidgetPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelSdapiResultsWidgetPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelSdapiResultsWidgetPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelSdapiResultsWidgetPrimaryCompositeKeyInput>;
};

export type ModelSdapiResultsWidgetPrimaryCompositeKeyInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelSdapiSeasonConnection = {
  __typename?: 'ModelSdapiSeasonConnection';
  items: Array<Maybe<SdapiSeason>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiSeasonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiSeasonFilterInput>>>;
  editorialData?: InputMaybe<ModelStringFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelSdapiSeasonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiSeasonFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelSdapiTournamentConnection = {
  __typename?: 'ModelSdapiTournamentConnection';
  items: Array<Maybe<SdapiTournament>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiTournamentDataWidgetConnection = {
  __typename?: 'ModelSdapiTournamentDataWidgetConnection';
  items: Array<Maybe<SdapiTournamentDataWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSdapiTournamentDataWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiTournamentDataWidgetFilterInput>>>;
  data?: InputMaybe<ModelStringFilterInput>;
  messageType?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelSdapiTournamentDataWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiTournamentDataWidgetFilterInput>>>;
  seasonAndTournamentType?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentType?: InputMaybe<ModelStringFilterInput>;
};

export type ModelSdapiTournamentFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSdapiTournamentFilterInput>>>;
  circuitType?: InputMaybe<ModelStringFilterInput>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelSdapiTournamentFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSdapiTournamentFilterInput>>>;
  seasonAndTournamentType?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentJson?: InputMaybe<ModelStringFilterInput>;
  type?: InputMaybe<ModelIDFilterInput>;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ModelStringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type ModelStringKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createEditorialData?: Maybe<EditorialData>;
  createSdapiCalendarWidget?: Maybe<SdapiCalendarWidget>;
  createSdapiCompetition?: Maybe<SdapiCompetition>;
  createSdapiLiveScoreWidget?: Maybe<SdapiLiveScoreWidget>;
  createSdapiMatch?: Maybe<SdapiMatch>;
  createSdapiPlayer?: Maybe<SdapiPlayer>;
  createSdapiRanking?: Maybe<SdapiRanking>;
  createSdapiRankingWidget?: Maybe<SdapiRankingWidget>;
  createSdapiResultsCategoriesWidget?: Maybe<SdapiResultsCategoriesWidget>;
  createSdapiResultsContainerWidget?: Maybe<SdapiResultsContainerWidget>;
  createSdapiResultsWidget?: Maybe<SdapiResultsWidget>;
  createSdapiSeason?: Maybe<SdapiSeason>;
  createSdapiTournament?: Maybe<SdapiTournament>;
  createSdapiTournamentDataWidget?: Maybe<SdapiTournamentDataWidget>;
  deleteEditorialData?: Maybe<EditorialData>;
  deleteSdapiCalendarWidget?: Maybe<SdapiCalendarWidget>;
  deleteSdapiCompetition?: Maybe<SdapiCompetition>;
  deleteSdapiLiveScoreWidget?: Maybe<SdapiLiveScoreWidget>;
  deleteSdapiMatch?: Maybe<SdapiMatch>;
  deleteSdapiPlayer?: Maybe<SdapiPlayer>;
  deleteSdapiRanking?: Maybe<SdapiRanking>;
  deleteSdapiRankingWidget?: Maybe<SdapiRankingWidget>;
  deleteSdapiResultsCategoriesWidget?: Maybe<SdapiResultsCategoriesWidget>;
  deleteSdapiResultsContainerWidget?: Maybe<SdapiResultsContainerWidget>;
  deleteSdapiResultsWidget?: Maybe<SdapiResultsWidget>;
  deleteSdapiSeason?: Maybe<SdapiSeason>;
  deleteSdapiTournament?: Maybe<SdapiTournament>;
  deleteSdapiTournamentDataWidget?: Maybe<SdapiTournamentDataWidget>;
  updateEditorialData?: Maybe<EditorialData>;
  updateSdapiCalendarWidget?: Maybe<SdapiCalendarWidget>;
  updateSdapiCompetition?: Maybe<SdapiCompetition>;
  updateSdapiLiveScoreWidget?: Maybe<SdapiLiveScoreWidget>;
  updateSdapiMatch?: Maybe<SdapiMatch>;
  updateSdapiPlayer?: Maybe<SdapiPlayer>;
  updateSdapiRanking?: Maybe<SdapiRanking>;
  updateSdapiRankingWidget?: Maybe<SdapiRankingWidget>;
  updateSdapiResultsCategoriesWidget?: Maybe<SdapiResultsCategoriesWidget>;
  updateSdapiResultsContainerWidget?: Maybe<SdapiResultsContainerWidget>;
  updateSdapiResultsWidget?: Maybe<SdapiResultsWidget>;
  updateSdapiSeason?: Maybe<SdapiSeason>;
  updateSdapiTournament?: Maybe<SdapiTournament>;
  updateSdapiTournamentDataWidget?: Maybe<SdapiTournamentDataWidget>;
};


export type MutationcreateEditorialDataArgs = {
  input: CreateEditorialDataInput;
};


export type MutationcreateSdapiCalendarWidgetArgs = {
  input: CreateSdapiCalendarWidgetInput;
};


export type MutationcreateSdapiCompetitionArgs = {
  input: CreateSdapiCompetitionInput;
};


export type MutationcreateSdapiLiveScoreWidgetArgs = {
  input: CreateSdapiLiveScoreWidgetInput;
};


export type MutationcreateSdapiMatchArgs = {
  input: CreateSdapiMatchInput;
};


export type MutationcreateSdapiPlayerArgs = {
  input: CreateSdapiPlayerInput;
};


export type MutationcreateSdapiRankingArgs = {
  input: CreateSdapiRankingInput;
};


export type MutationcreateSdapiRankingWidgetArgs = {
  input: CreateSdapiRankingWidgetInput;
};


export type MutationcreateSdapiResultsCategoriesWidgetArgs = {
  input: CreateSdapiResultsCategoriesWidgetInput;
};


export type MutationcreateSdapiResultsContainerWidgetArgs = {
  input: CreateSdapiResultsContainerWidgetInput;
};


export type MutationcreateSdapiResultsWidgetArgs = {
  input: CreateSdapiResultsWidgetInput;
};


export type MutationcreateSdapiSeasonArgs = {
  input: CreateSdapiSeasonInput;
};


export type MutationcreateSdapiTournamentArgs = {
  input: CreateSdapiTournamentInput;
};


export type MutationcreateSdapiTournamentDataWidgetArgs = {
  input: CreateSdapiTournamentDataWidgetInput;
};


export type MutationdeleteEditorialDataArgs = {
  input: DeleteEditorialDataInput;
};


export type MutationdeleteSdapiCalendarWidgetArgs = {
  input: DeleteSdapiCalendarWidgetInput;
};


export type MutationdeleteSdapiCompetitionArgs = {
  input: DeleteSdapiCompetitionInput;
};


export type MutationdeleteSdapiLiveScoreWidgetArgs = {
  input: DeleteSdapiLiveScoreWidgetInput;
};


export type MutationdeleteSdapiMatchArgs = {
  input: DeleteSdapiMatchInput;
};


export type MutationdeleteSdapiPlayerArgs = {
  input: DeleteSdapiPlayerInput;
};


export type MutationdeleteSdapiRankingArgs = {
  input: DeleteSdapiRankingInput;
};


export type MutationdeleteSdapiRankingWidgetArgs = {
  input: DeleteSdapiRankingWidgetInput;
};


export type MutationdeleteSdapiResultsCategoriesWidgetArgs = {
  input: DeleteSdapiResultsCategoriesWidgetInput;
};


export type MutationdeleteSdapiResultsContainerWidgetArgs = {
  input: DeleteSdapiResultsContainerWidgetInput;
};


export type MutationdeleteSdapiResultsWidgetArgs = {
  input: DeleteSdapiResultsWidgetInput;
};


export type MutationdeleteSdapiSeasonArgs = {
  input: DeleteSdapiSeasonInput;
};


export type MutationdeleteSdapiTournamentArgs = {
  input: DeleteSdapiTournamentInput;
};


export type MutationdeleteSdapiTournamentDataWidgetArgs = {
  input: DeleteSdapiTournamentDataWidgetInput;
};


export type MutationupdateEditorialDataArgs = {
  input: UpdateEditorialDataInput;
};


export type MutationupdateSdapiCalendarWidgetArgs = {
  input: UpdateSdapiCalendarWidgetInput;
};


export type MutationupdateSdapiCompetitionArgs = {
  input: UpdateSdapiCompetitionInput;
};


export type MutationupdateSdapiLiveScoreWidgetArgs = {
  input: UpdateSdapiLiveScoreWidgetInput;
};


export type MutationupdateSdapiMatchArgs = {
  input: UpdateSdapiMatchInput;
};


export type MutationupdateSdapiPlayerArgs = {
  input: UpdateSdapiPlayerInput;
};


export type MutationupdateSdapiRankingArgs = {
  input: UpdateSdapiRankingInput;
};


export type MutationupdateSdapiRankingWidgetArgs = {
  input: UpdateSdapiRankingWidgetInput;
};


export type MutationupdateSdapiResultsCategoriesWidgetArgs = {
  input: UpdateSdapiResultsCategoriesWidgetInput;
};


export type MutationupdateSdapiResultsContainerWidgetArgs = {
  input: UpdateSdapiResultsContainerWidgetInput;
};


export type MutationupdateSdapiResultsWidgetArgs = {
  input: UpdateSdapiResultsWidgetInput;
};


export type MutationupdateSdapiSeasonArgs = {
  input: UpdateSdapiSeasonInput;
};


export type MutationupdateSdapiTournamentArgs = {
  input: UpdateSdapiTournamentInput;
};


export type MutationupdateSdapiTournamentDataWidgetArgs = {
  input: UpdateSdapiTournamentDataWidgetInput;
};

export type Query = {
  __typename?: 'Query';
  getEditorialData?: Maybe<EditorialData>;
  getEditorialDataById?: Maybe<ModelEditorialDataConnection>;
  getSdapiCalendarWidget?: Maybe<SdapiCalendarWidget>;
  getSdapiCompetition?: Maybe<SdapiCompetition>;
  getSdapiCompetitionByTournament?: Maybe<ModelSdapiCompetitionConnection>;
  getSdapiLiveScoreWidget?: Maybe<SdapiLiveScoreWidget>;
  getSdapiMatch?: Maybe<SdapiMatch>;
  getSdapiMatchByDate?: Maybe<ModelSdapiMatchConnection>;
  getSdapiMatchById?: Maybe<ModelSdapiMatchConnection>;
  getSdapiMatchByRound?: Maybe<ModelSdapiMatchConnection>;
  getSdapiMatchBySeasonAndCompId?: Maybe<ModelSdapiMatchConnection>;
  getSdapiMatchCompetitionByTournament?: Maybe<ModelSdapiCompetitionConnection>;
  getSdapiPlayer?: Maybe<SdapiPlayer>;
  getSdapiRanking?: Maybe<SdapiRanking>;
  getSdapiRankingWidget?: Maybe<SdapiRankingWidget>;
  getSdapiResultsCategoriesWidget?: Maybe<SdapiResultsCategoriesWidget>;
  getSdapiResultsContainerWidget?: Maybe<SdapiResultsContainerWidget>;
  getSdapiResultsWidget?: Maybe<SdapiResultsWidget>;
  getSdapiSeason?: Maybe<SdapiSeason>;
  getSdapiTournament?: Maybe<SdapiTournament>;
  getSdapiTournamentDataWidget?: Maybe<SdapiTournamentDataWidget>;
  getSdapiTournamentsById?: Maybe<ModelSdapiTournamentConnection>;
  getSdapiTournamentsBySeasonId?: Maybe<ModelSdapiTournamentConnection>;
  listEditorialDatas?: Maybe<ModelEditorialDataConnection>;
  listSdapiCalendarWidgets?: Maybe<ModelSdapiCalendarWidgetConnection>;
  listSdapiCompetitions?: Maybe<ModelSdapiCompetitionConnection>;
  listSdapiLiveScoreWidgets?: Maybe<ModelSdapiLiveScoreWidgetConnection>;
  listSdapiMatchs?: Maybe<ModelSdapiMatchConnection>;
  listSdapiPlayers?: Maybe<ModelSdapiPlayerConnection>;
  listSdapiRankingWidgets?: Maybe<ModelSdapiRankingWidgetConnection>;
  listSdapiRankings?: Maybe<ModelSdapiRankingConnection>;
  listSdapiResultsCategoriesWidgets?: Maybe<ModelSdapiResultsCategoriesWidgetConnection>;
  listSdapiResultsContainerWidgets?: Maybe<ModelSdapiResultsContainerWidgetConnection>;
  listSdapiResultsWidgets?: Maybe<ModelSdapiResultsWidgetConnection>;
  listSdapiSeasons?: Maybe<ModelSdapiSeasonConnection>;
  listSdapiTournamentDataWidgets?: Maybe<ModelSdapiTournamentDataWidgetConnection>;
  listSdapiTournaments?: Maybe<ModelSdapiTournamentConnection>;
};


export type QuerygetEditorialDataArgs = {
  editorialDataId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetEditorialDataByIdArgs = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetSdapiCalendarWidgetArgs = {
  circuitType: Scalars['String']['input'];
  tournamentFilter: Scalars['String']['input'];
};


export type QuerygetSdapiCompetitionArgs = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetSdapiCompetitionByTournamentArgs = {
  filter?: InputMaybe<ModelSdapiCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerygetSdapiLiveScoreWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetSdapiMatchArgs = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetSdapiMatchByDateArgs = {
  date?: InputMaybe<ModelIntKeyConditionInput>;
  filter?: InputMaybe<ModelSdapiMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetSdapiMatchByIdArgs = {
  filter?: InputMaybe<ModelSdapiMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetSdapiMatchByRoundArgs = {
  filter?: InputMaybe<ModelSdapiMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<ModelStringKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetSdapiMatchBySeasonAndCompIdArgs = {
  filter?: InputMaybe<ModelSdapiMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetSdapiMatchCompetitionByTournamentArgs = {
  filter?: InputMaybe<ModelSdapiCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerygetSdapiPlayerArgs = {
  playerId: Scalars['ID']['input'];
};


export type QuerygetSdapiRankingArgs = {
  circuitType: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};


export type QuerygetSdapiRankingWidgetArgs = {
  circuitType: Scalars['ID']['input'];
};


export type QuerygetSdapiResultsCategoriesWidgetArgs = {
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};


export type QuerygetSdapiResultsContainerWidgetArgs = {
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};


export type QuerygetSdapiResultsWidgetArgs = {
  competitionId: Scalars['ID']['input'];
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetSdapiSeasonArgs = {
  seasonId: Scalars['ID']['input'];
};


export type QuerygetSdapiTournamentArgs = {
  seasonAndTournamentType: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type QuerygetSdapiTournamentDataWidgetArgs = {
  seasonAndTournamentType: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type QuerygetSdapiTournamentsByIdArgs = {
  filter?: InputMaybe<ModelSdapiTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerygetSdapiTournamentsBySeasonIdArgs = {
  filter?: InputMaybe<ModelSdapiTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistEditorialDatasArgs = {
  editorialDataId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiCalendarWidgetsArgs = {
  circuitType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ModelSdapiCalendarWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentFilter?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QuerylistSdapiCompetitionsArgs = {
  competitionId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelSdapiCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiLiveScoreWidgetsArgs = {
  filter?: InputMaybe<ModelSdapiLiveScoreWidgetFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiMatchsArgs = {
  filter?: InputMaybe<ModelSdapiMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiPlayersArgs = {
  filter?: InputMaybe<ModelSdapiPlayerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiRankingWidgetsArgs = {
  circuitType?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelSdapiRankingWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiRankingsArgs = {
  circuitType?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelSdapiRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<ModelIntKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiResultsCategoriesWidgetsArgs = {
  filter?: InputMaybe<ModelSdapiResultsCategoriesWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonIdTournamentType?: InputMaybe<ModelSdapiResultsCategoriesWidgetPrimaryCompositeKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistSdapiResultsContainerWidgetsArgs = {
  filter?: InputMaybe<ModelSdapiResultsContainerWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonIdTournamentType?: InputMaybe<ModelSdapiResultsContainerWidgetPrimaryCompositeKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistSdapiResultsWidgetsArgs = {
  day?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelSdapiResultsWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonIdCompetitionId?: InputMaybe<ModelSdapiResultsWidgetPrimaryCompositeKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiSeasonsArgs = {
  filter?: InputMaybe<ModelSdapiSeasonFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSdapiTournamentDataWidgetsArgs = {
  filter?: InputMaybe<ModelSdapiTournamentDataWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerylistSdapiTournamentsArgs = {
  filter?: InputMaybe<ModelSdapiTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};

export type RankingWidgetInfo = {
  __typename?: 'RankingWidgetInfo';
  nationality?: Maybe<Scalars['String']['output']>;
  playerName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
};

export type RankingWidgetInfoInput = {
  nationality?: InputMaybe<Scalars['String']['input']>;
  playerName?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
};

export type ResultWidgetPlayer = {
  __typename?: 'ResultWidgetPlayer';
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
};

export type ResultWidgetPlayerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
};

export type ResultWidgetPosition = {
  __typename?: 'ResultWidgetPosition';
  isServing?: Maybe<Scalars['Boolean']['output']>;
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<Array<Maybe<ResultWidgetPlayer>>>;
  score?: Maybe<Array<Maybe<ResultWidgetScore>>>;
};

export type ResultWidgetPositionInput = {
  isServing?: InputMaybe<Scalars['Boolean']['input']>;
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  players?: InputMaybe<Array<InputMaybe<ResultWidgetPlayerInput>>>;
  score?: InputMaybe<Array<InputMaybe<ResultWidgetScoreInput>>>;
};

export type ResultWidgetScore = {
  __typename?: 'ResultWidgetScore';
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  set?: Maybe<Scalars['String']['output']>;
  tie?: Maybe<Scalars['String']['output']>;
};

export type ResultWidgetScoreInput = {
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  tie?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsCategoriesWidgetAdv = {
  __typename?: 'ResultsCategoriesWidgetAdv';
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type ResultsCategoriesWidgetAdvInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsCategoriesWidgetInfo = {
  __typename?: 'ResultsCategoriesWidgetInfo';
  dates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResultsCategoriesWidgetInfoInput = {
  dates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsWidgetMatch = {
  __typename?: 'ResultsWidgetMatch';
  firstPosition?: Maybe<ResultWidgetPosition>;
  resultType?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  secondPosition?: Maybe<ResultWidgetPosition>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ResultsWidgetMatchInput = {
  firstPosition?: InputMaybe<ResultWidgetPositionInput>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  secondPosition?: InputMaybe<ResultWidgetPositionInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SdapiCalendarWidget = {
  __typename?: 'SdapiCalendarWidget';
  circuitCalendarLink?: Maybe<Scalars['String']['output']>;
  circuitType: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  filterList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tournamentFilter: Scalars['String']['output'];
  tournaments?: Maybe<Array<Maybe<CalendarWidgetInfo>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiCompetition = {
  __typename?: 'SdapiCompetition';
  competitionId: Scalars['ID']['output'];
  competitionJson: Scalars['AWSJSON']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  matches?: Maybe<ModelSdapiMatchConnection>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonAndTournamentType: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  sex?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<SdapiTournament>;
  tournamentId: Scalars['ID']['output'];
  tournamentType: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type SdapiCompetitionmatchesArgs = {
  filter?: InputMaybe<ModelSdapiMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type SdapiLiveScoreWidget = {
  __typename?: 'SdapiLiveScoreWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  ctaUrls?: Maybe<LiveScoreWidgetCtaUrl>;
  id: Scalars['ID']['output'];
  liveTournaments?: Maybe<Array<Maybe<LiveScoreWidgetTournament>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiMatch = {
  __typename?: 'SdapiMatch';
  competition?: Maybe<SdapiCompetition>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['Int']['output']>;
  matchId: Scalars['ID']['output'];
  matchLiveJson?: Maybe<Scalars['AWSJSON']['output']>;
  matchScheduleJson?: Maybe<Scalars['AWSJSON']['output']>;
  playerA1?: Maybe<SdapiPlayer>;
  playerA1Id?: Maybe<Scalars['ID']['output']>;
  playerA2?: Maybe<SdapiPlayer>;
  playerA2Id?: Maybe<Scalars['ID']['output']>;
  playerB1?: Maybe<SdapiPlayer>;
  playerB1Id?: Maybe<Scalars['ID']['output']>;
  playerB2?: Maybe<SdapiPlayer>;
  playerB2Id?: Maybe<Scalars['ID']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tournamentId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiPlayer = {
  __typename?: 'SdapiPlayer';
  createdAt: Scalars['AWSDateTime']['output'];
  playerId: Scalars['ID']['output'];
  playerJson?: Maybe<Scalars['AWSJSON']['output']>;
  playerStatsJson?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiRanking = {
  __typename?: 'SdapiRanking';
  circuitType: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  player?: Maybe<SdapiPlayer>;
  playerId: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  rankingJson: Scalars['AWSJSON']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiRankingWidget = {
  __typename?: 'SdapiRankingWidget';
  circuitType: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  rankings?: Maybe<Array<Maybe<RankingWidgetInfo>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiResultsCategoriesWidget = {
  __typename?: 'SdapiResultsCategoriesWidget';
  adv?: Maybe<ResultsCategoriesWidgetAdv>;
  categories?: Maybe<Array<Maybe<ResultsCategoriesWidgetInfo>>>;
  createdAt: Scalars['AWSDateTime']['output'];
  seasonId: Scalars['ID']['output'];
  tournamentId: Scalars['ID']['output'];
  tournamentType: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiResultsContainerWidget = {
  __typename?: 'SdapiResultsContainerWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  seasonId: Scalars['ID']['output'];
  ssi?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tournamentId: Scalars['ID']['output'];
  tournamentType: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiResultsWidget = {
  __typename?: 'SdapiResultsWidget';
  categoryName?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  day: Scalars['ID']['output'];
  matches?: Maybe<Array<Maybe<ResultsWidgetMatch>>>;
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SdapiSeason = {
  __typename?: 'SdapiSeason';
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<Scalars['AWSJSON']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  seasonId: Scalars['ID']['output'];
  tournaments?: Maybe<ModelSdapiTournamentConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type SdapiSeasontournamentsArgs = {
  filter?: InputMaybe<ModelSdapiTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type SdapiTournament = {
  __typename?: 'SdapiTournament';
  circuitType: Scalars['String']['output'];
  competitions?: Maybe<ModelSdapiCompetitionConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<EditorialData>;
  editorialDataId: Scalars['ID']['output'];
  season?: Maybe<SdapiSeason>;
  seasonAndTournamentType: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  tournamentId: Scalars['ID']['output'];
  tournamentJson: Scalars['AWSJSON']['output'];
  type: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type SdapiTournamentcompetitionsArgs = {
  filter?: InputMaybe<ModelSdapiCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type SdapiTournamentDataWidget = {
  __typename?: 'SdapiTournamentDataWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  data?: Maybe<Scalars['AWSJSON']['output']>;
  messageType: Scalars['String']['output'];
  seasonAndTournamentType: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  tournamentId: Scalars['ID']['output'];
  tournamentType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onCreateEditorialData?: Maybe<EditorialData>;
  onCreateSdapiCalendarWidget?: Maybe<SdapiCalendarWidget>;
  onCreateSdapiCompetition?: Maybe<SdapiCompetition>;
  onCreateSdapiLiveScoreWidget?: Maybe<SdapiLiveScoreWidget>;
  onCreateSdapiMatch?: Maybe<SdapiMatch>;
  onCreateSdapiPlayer?: Maybe<SdapiPlayer>;
  onCreateSdapiRanking?: Maybe<SdapiRanking>;
  onCreateSdapiRankingWidget?: Maybe<SdapiRankingWidget>;
  onCreateSdapiResultsCategoriesWidget?: Maybe<SdapiResultsCategoriesWidget>;
  onCreateSdapiResultsContainerWidget?: Maybe<SdapiResultsContainerWidget>;
  onCreateSdapiResultsWidget?: Maybe<SdapiResultsWidget>;
  onCreateSdapiSeason?: Maybe<SdapiSeason>;
  onCreateSdapiTournament?: Maybe<SdapiTournament>;
  onCreateSdapiTournamentDataWidget?: Maybe<SdapiTournamentDataWidget>;
  onDeleteEditorialData?: Maybe<EditorialData>;
  onDeleteSdapiCalendarWidget?: Maybe<SdapiCalendarWidget>;
  onDeleteSdapiCompetition?: Maybe<SdapiCompetition>;
  onDeleteSdapiLiveScoreWidget?: Maybe<SdapiLiveScoreWidget>;
  onDeleteSdapiMatch?: Maybe<SdapiMatch>;
  onDeleteSdapiPlayer?: Maybe<SdapiPlayer>;
  onDeleteSdapiRanking?: Maybe<SdapiRanking>;
  onDeleteSdapiRankingWidget?: Maybe<SdapiRankingWidget>;
  onDeleteSdapiResultsCategoriesWidget?: Maybe<SdapiResultsCategoriesWidget>;
  onDeleteSdapiResultsContainerWidget?: Maybe<SdapiResultsContainerWidget>;
  onDeleteSdapiResultsWidget?: Maybe<SdapiResultsWidget>;
  onDeleteSdapiSeason?: Maybe<SdapiSeason>;
  onDeleteSdapiTournament?: Maybe<SdapiTournament>;
  onDeleteSdapiTournamentDataWidget?: Maybe<SdapiTournamentDataWidget>;
  onUpdateEditorialData?: Maybe<EditorialData>;
  onUpdateSdapiCalendarWidget?: Maybe<SdapiCalendarWidget>;
  onUpdateSdapiCompetition?: Maybe<SdapiCompetition>;
  onUpdateSdapiLiveScoreById?: Maybe<SdapiLiveScoreWidget>;
  onUpdateSdapiLiveScoreWidget?: Maybe<SdapiLiveScoreWidget>;
  onUpdateSdapiMatch?: Maybe<SdapiMatch>;
  onUpdateSdapiPlayer?: Maybe<SdapiPlayer>;
  onUpdateSdapiRanking?: Maybe<SdapiRanking>;
  onUpdateSdapiRankingWidget?: Maybe<SdapiRankingWidget>;
  onUpdateSdapiRankingWidgetByCircuitType?: Maybe<SdapiRankingWidget>;
  onUpdateSdapiResultsCategoriesWidget?: Maybe<SdapiResultsCategoriesWidget>;
  onUpdateSdapiResultsContainerWidget?: Maybe<SdapiResultsContainerWidget>;
  onUpdateSdapiResultsWidget?: Maybe<SdapiResultsWidget>;
  onUpdateSdapiResultsWidgetByDay?: Maybe<SdapiResultsWidget>;
  onUpdateSdapiSeason?: Maybe<SdapiSeason>;
  onUpdateSdapiTournament?: Maybe<SdapiTournament>;
  onUpdateSdapiTournamentDataWidget?: Maybe<SdapiTournamentDataWidget>;
};


export type SubscriptiononUpdateSdapiLiveScoreByIdArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptiononUpdateSdapiRankingWidgetByCircuitTypeArgs = {
  circuitType: Scalars['ID']['input'];
};


export type SubscriptiononUpdateSdapiResultsWidgetByDayArgs = {
  competitionId: Scalars['ID']['input'];
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type UpdateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateSdapiCalendarWidgetInput = {
  circuitCalendarLink?: InputMaybe<Scalars['String']['input']>;
  circuitType: Scalars['String']['input'];
  filterList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentFilter: Scalars['String']['input'];
  tournaments?: InputMaybe<Array<InputMaybe<CalendarWidgetInfoInput>>>;
};

export type UpdateSdapiCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  competitionJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  seasonId: Scalars['ID']['input'];
  sex?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
  tournamentType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSdapiLiveScoreWidgetInput = {
  ctaUrls?: InputMaybe<LiveScoreWidgetCtaUrlInput>;
  id: Scalars['ID']['input'];
  liveTournaments?: InputMaybe<Array<InputMaybe<LiveScoreWidgetTournamentInput>>>;
};

export type UpdateSdapiMatchInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['ID']['input'];
  matchLiveJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchScheduleJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerA1Id?: InputMaybe<Scalars['ID']['input']>;
  playerA2Id?: InputMaybe<Scalars['ID']['input']>;
  playerB1Id?: InputMaybe<Scalars['ID']['input']>;
  playerB2Id?: InputMaybe<Scalars['ID']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSdapiPlayerInput = {
  playerId: Scalars['ID']['input'];
  playerJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerStatsJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateSdapiRankingInput = {
  circuitType: Scalars['ID']['input'];
  playerId?: InputMaybe<Scalars['ID']['input']>;
  rank: Scalars['Int']['input'];
  rankingJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateSdapiRankingWidgetInput = {
  circuitType: Scalars['ID']['input'];
  rankings?: InputMaybe<Array<InputMaybe<RankingWidgetInfoInput>>>;
};

export type UpdateSdapiResultsCategoriesWidgetInput = {
  adv?: InputMaybe<ResultsCategoriesWidgetAdvInput>;
  categories?: InputMaybe<Array<InputMaybe<ResultsCategoriesWidgetInfoInput>>>;
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type UpdateSdapiResultsContainerWidgetInput = {
  seasonId: Scalars['ID']['input'];
  ssi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type UpdateSdapiResultsWidgetInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['ID']['input'];
  matches?: InputMaybe<Array<InputMaybe<ResultsWidgetMatchInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateSdapiSeasonInput = {
  editorialData?: InputMaybe<Scalars['AWSJSON']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateSdapiTournamentDataWidgetInput = {
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  tournamentId: Scalars['ID']['input'];
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSdapiTournamentInput = {
  circuitType?: InputMaybe<Scalars['String']['input']>;
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  tournamentId: Scalars['ID']['input'];
  tournamentJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
};

export type getSdapiCalendarWidgetQueryVariables = Exact<{
  circuitType: Scalars['String']['input'];
  tournamentFilter: Scalars['String']['input'];
}>;


export type getSdapiCalendarWidgetQuery = { __typename?: 'Query', getSdapiCalendarWidget?: { __typename?: 'SdapiCalendarWidget', circuitType: string, tournamentFilter: string, filterList?: Array<string | null> | null, circuitCalendarLink?: string | null, tournaments?: Array<{ __typename?: 'CalendarWidgetInfo', endDate?: string | null, startDate?: string | null, status?: string | null, surface?: string | null, tournamentName?: string | null, tournamentPlace?: string | null, tournamentType?: string | null, href?: string | null } | null> | null } | null };

export type getSdapiLiveScoreWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type getSdapiLiveScoreWidgetQuery = { __typename?: 'Query', getSdapiLiveScoreWidget?: { __typename?: 'SdapiLiveScoreWidget', id: string, liveTournaments?: Array<{ __typename?: 'LiveScoreWidgetTournament', competitionId?: string | null, seasonId?: string | null, categoryName?: string | null, circuitType?: string | null, tournamentName?: string | null, tournamentType?: string | null, resultsUrl?: string | null, matches?: Array<{ __typename?: 'LiveScoreWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null, secondPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null } | null> | null } | null> | null, ctaUrls?: { __typename?: 'LiveScoreWidgetCtaUrl', atpCalendarUrl?: string | null, wtaCalendarUrl?: string | null, atpRankingUrl?: string | null, wtaRankingUrl?: string | null } | null } | null };

export type getSdapiRankingWidgetQueryVariables = Exact<{
  circuitType: Scalars['ID']['input'];
}>;


export type getSdapiRankingWidgetQuery = { __typename?: 'Query', getSdapiRankingWidget?: { __typename?: 'SdapiRankingWidget', circuitType: string, rankings?: Array<{ __typename?: 'RankingWidgetInfo', rank?: number | null, trend?: string | null, nationality?: string | null, playerName?: string | null, points?: string | null } | null> | null } | null };

export type getSdapiResultsCategoriesWidgetQueryVariables = Exact<{
  tournamentId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
}>;


export type getSdapiResultsCategoriesWidgetQuery = { __typename?: 'Query', getSdapiResultsCategoriesWidget?: { __typename?: 'SdapiResultsCategoriesWidget', tournamentType: string, categories?: Array<{ __typename?: 'ResultsCategoriesWidgetInfo', name?: string | null, dates?: Array<string | null> | null } | null> | null, adv?: { __typename?: 'ResultsCategoriesWidgetAdv', link?: string | null, image?: string | null } | null } | null };

export type getSdapiResultsContainerWidgetQueryVariables = Exact<{
  tournamentId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
}>;


export type getSdapiResultsContainerWidgetQuery = { __typename?: 'Query', getSdapiResultsContainerWidget?: { __typename?: 'SdapiResultsContainerWidget', ssi?: Array<string | null> | null } | null };

export type getSdapiResultsWidgetQueryVariables = Exact<{
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
}>;


export type getSdapiResultsWidgetQuery = { __typename?: 'Query', getSdapiResultsWidget?: { __typename?: 'SdapiResultsWidget', seasonId: string, competitionId: string, day: string, categoryName?: string | null, date?: string | null, matches?: Array<{ __typename?: 'ResultsWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null, secondPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null } | null> | null } | null };

export type SdapiLiveScoreSubcriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SdapiLiveScoreSubcriptionSubscription = { __typename?: 'Subscription', onUpdateSdapiLiveScoreById?: { __typename?: 'SdapiLiveScoreWidget', id: string, liveTournaments?: Array<{ __typename?: 'LiveScoreWidgetTournament', competitionId?: string | null, seasonId?: string | null, categoryName?: string | null, circuitType?: string | null, tournamentName?: string | null, tournamentType?: string | null, resultsUrl?: string | null, matches?: Array<{ __typename?: 'LiveScoreWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null, secondPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null } | null> | null } | null> | null } | null };

export type onUpdateSdapiRankingWidgetByCircuitTypeSubscriptionVariables = Exact<{
  circuitType: Scalars['ID']['input'];
}>;


export type onUpdateSdapiRankingWidgetByCircuitTypeSubscription = { __typename?: 'Subscription', onUpdateSdapiRankingWidgetByCircuitType?: { __typename?: 'SdapiRankingWidget', circuitType: string, rankings?: Array<{ __typename?: 'RankingWidgetInfo', nationality?: string | null, playerName?: string | null, points?: string | null, rank?: number | null, trend?: string | null } | null> | null } | null };

export type onUpdateSdapiResultsWidgetByDaySubscriptionVariables = Exact<{
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
}>;


export type onUpdateSdapiResultsWidgetByDaySubscription = { __typename?: 'Subscription', onUpdateSdapiResultsWidgetByDay?: { __typename?: 'SdapiResultsWidget', seasonId: string, competitionId: string, day: string, categoryName?: string | null, date?: string | null, matches?: Array<{ __typename?: 'ResultsWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null, secondPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null } | null> | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any> | undefined) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const getSdapiCalendarWidgetDocument = new TypedDocumentString(`
    query getSdapiCalendarWidget($circuitType: String!, $tournamentFilter: String!) {
  getSdapiCalendarWidget(
    circuitType: $circuitType
    tournamentFilter: $tournamentFilter
  ) {
    circuitType
    tournamentFilter
    filterList
    circuitCalendarLink
    tournaments {
      endDate
      startDate
      status
      surface
      tournamentName
      tournamentPlace
      tournamentType
      href
    }
  }
}
    `) as unknown as TypedDocumentString<getSdapiCalendarWidgetQuery, getSdapiCalendarWidgetQueryVariables>;
export const getSdapiLiveScoreWidgetDocument = new TypedDocumentString(`
    query getSdapiLiveScoreWidget {
  getSdapiLiveScoreWidget(id: "unique") {
    id
    liveTournaments {
      competitionId
      seasonId
      categoryName
      circuitType
      tournamentName
      tournamentType
      resultsUrl
      matches {
        status
        startDate
        roundName
        resultType
        firstPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
        }
        secondPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
        }
      }
    }
    ctaUrls {
      atpCalendarUrl
      wtaCalendarUrl
      atpRankingUrl
      wtaRankingUrl
    }
  }
}
    `) as unknown as TypedDocumentString<getSdapiLiveScoreWidgetQuery, getSdapiLiveScoreWidgetQueryVariables>;
export const getSdapiRankingWidgetDocument = new TypedDocumentString(`
    query getSdapiRankingWidget($circuitType: ID!) {
  getSdapiRankingWidget(circuitType: $circuitType) {
    circuitType
    rankings {
      rank
      trend
      nationality
      playerName
      points
    }
  }
}
    `) as unknown as TypedDocumentString<getSdapiRankingWidgetQuery, getSdapiRankingWidgetQueryVariables>;
export const getSdapiResultsCategoriesWidgetDocument = new TypedDocumentString(`
    query getSdapiResultsCategoriesWidget($tournamentId: ID!, $seasonId: ID!, $tournamentType: ID!) {
  getSdapiResultsCategoriesWidget(
    tournamentId: $tournamentId
    seasonId: $seasonId
    tournamentType: $tournamentType
  ) {
    categories {
      name
      dates
    }
    adv {
      link
      image
    }
    tournamentType
  }
}
    `) as unknown as TypedDocumentString<getSdapiResultsCategoriesWidgetQuery, getSdapiResultsCategoriesWidgetQueryVariables>;
export const getSdapiResultsContainerWidgetDocument = new TypedDocumentString(`
    query getSdapiResultsContainerWidget($tournamentId: ID!, $seasonId: ID!, $tournamentType: ID!) {
  getSdapiResultsContainerWidget(
    tournamentId: $tournamentId
    seasonId: $seasonId
    tournamentType: $tournamentType
  ) {
    ssi
  }
}
    `) as unknown as TypedDocumentString<getSdapiResultsContainerWidgetQuery, getSdapiResultsContainerWidgetQueryVariables>;
export const getSdapiResultsWidgetDocument = new TypedDocumentString(`
    query getSdapiResultsWidget($day: ID!, $seasonId: ID!, $competitionId: ID!) {
  getSdapiResultsWidget(
    day: $day
    seasonId: $seasonId
    competitionId: $competitionId
  ) {
    seasonId
    competitionId
    day
    categoryName
    date
    matches {
      status
      startDate
      roundName
      resultType
      firstPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        isWinner
      }
      secondPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        isWinner
      }
    }
  }
}
    `) as unknown as TypedDocumentString<getSdapiResultsWidgetQuery, getSdapiResultsWidgetQueryVariables>;
export const SdapiLiveScoreSubcriptionDocument = new TypedDocumentString(`
    subscription SdapiLiveScoreSubcription {
  onUpdateSdapiLiveScoreById(id: "unique") {
    id
    liveTournaments {
      competitionId
      seasonId
      categoryName
      circuitType
      tournamentName
      tournamentType
      resultsUrl
      matches {
        status
        startDate
        roundName
        resultType
        firstPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
        }
        secondPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SdapiLiveScoreSubcriptionSubscription, SdapiLiveScoreSubcriptionSubscriptionVariables>;
export const onUpdateSdapiRankingWidgetByCircuitTypeDocument = new TypedDocumentString(`
    subscription onUpdateSdapiRankingWidgetByCircuitType($circuitType: ID!) {
  onUpdateSdapiRankingWidgetByCircuitType(circuitType: $circuitType) {
    rankings {
      nationality
      playerName
      points
      rank
      trend
    }
    circuitType
  }
}
    `) as unknown as TypedDocumentString<onUpdateSdapiRankingWidgetByCircuitTypeSubscription, onUpdateSdapiRankingWidgetByCircuitTypeSubscriptionVariables>;
export const onUpdateSdapiResultsWidgetByDayDocument = new TypedDocumentString(`
    subscription onUpdateSdapiResultsWidgetByDay($day: ID!, $seasonId: ID!, $competitionId: ID!) {
  onUpdateSdapiResultsWidgetByDay(
    day: $day
    seasonId: $seasonId
    competitionId: $competitionId
  ) {
    seasonId
    competitionId
    day
    categoryName
    date
    matches {
      status
      startDate
      roundName
      resultType
      firstPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        isWinner
      }
      secondPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        isWinner
      }
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateSdapiResultsWidgetByDaySubscription, onUpdateSdapiResultsWidgetByDaySubscriptionVariables>;